import { BackkdropLoader } from '@/components/backdroploader';
import React from 'react';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Home = React.lazy(() => import('@/views/home/main'));
export const HomeRoutes = (
	<Route
		index
		element={
			<Suspense fallback={<BackkdropLoader />}>
				<Home />
			</Suspense>
		}
	/>
);
